<template>
  <DashboardVideo />
  <div
    class="container h-100 d-flex align-items-center justify-content-center z-2"
  >
    <div class="row mobile align-content-between g-0">
      <TypeTopNav
        :heading="this.viewType"
        :routeBack="{ name: 'DashboardHome' }"
      />
      <div class="col-12 d-flex align-items-center justify-content-center z-2">
        <div class="row g-0">
          <div class="col-12">
            <template v-for="(asset, index) in assetTypes" :key="asset?.Guid">
              <!-- Video links -->
              <router-link
                v-if="
                  asset.LinkName.includes('walkthrough') ||
                  asset.LinkName.includes('flythrough')
                "
                :to="{
                  name: 'VideoView',
                  params: {
                    guid: collection?.previewVideoIds || '123',
                    collectionId: this.theme.videoLibraryId,
                  },
                }"
                :class="['btn-theme-menu row ml-0', 'mb-2']"
              >
                <div class="col-4">
                  <img
                    :src="theme.videosIcon"
                    :alt="asset.ObjectName"
                    class="float-right"
                  />
                </div>
                <div class="col-8">
                  {{ asset.ObjectName.replace("Gia", "GIA") }}
                </div>
              </router-link>

              <!-- Panorama links -->
              <router-link
                v-if="this.viewType == '360-tour'"
                :to="{
                  name: 'AssetViewDetail',
                  params: {
                    assetType: this.viewType,
                    viewType: asset.LinkName,
                    order: 0,
                  },
                }"
                :class="['btn-theme-menu row ml-0', 'mb-2']"
              >
                <div class="col-12 text-center">
                  {{ asset.ObjectName }}
                </div>
              </router-link>

              <!-- Renders links -->
              <router-link
                v-if="asset.LinkName.includes('renders')"
                :to="{
                  name: asset.ComponentName,
                  params: {
                    assetView: this.viewType,
                    viewType: asset.LinkName,
                  },
                }"
                :class="['btn-theme-menu row ml-0', 'mb-2']"
              >
                <div class="col-4">
                  <img
                    :src="theme.rendersIcon"
                    :alt="asset.ObjectName"
                    class="float-right"
                  />
                </div>
                <div class="col-8">
                  {{ asset.ObjectName }}
                </div>
              </router-link>

              <router-link
                v-if="asset.LinkName.includes('balcony-views')"
                :to="{
                  name: 'AssetList',
                  params: {
                    assetType: this.viewType,
                    viewType: asset.LinkName,
                  },
                }"
                :class="['btn-theme-menu row ml-0', 'mb-2']"
              >
                <div class="col-4">
                  <img
                    :src="theme.panoramasIcon"
                    :alt="asset.ObjectName"
                    class="float-right"
                  />
                </div>
                <div class="col-8">
                  {{ asset.ObjectName }}
                </div>
              </router-link>
            </template>
          </div>
        </div>
      </div>

      <TypeBotNav />
    </div>
  </div>
  <OffCanvas />
</template>

<script>
import DashboardVideo from "@/components/DashboardVideo.vue";
import TypeTopNav from "@/components/TypeTopNav.vue";
import TypeBotNav from "@/components/TypeBotNav.vue";
import OffCanvas from "@/components/OffCanvas.vue";
import global from "../global";
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";
import sortArray from "sort-array";

export default {
  name: "AssetType",
  props: {
    assetType: String,
    viewType: String,
  },
  components: {
    DashboardVideo,
    TypeTopNav,
    TypeBotNav,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      collection: null,
      componentName: "AssetView",
      folderStructure: encodeURIComponent(
        this.theme.devFolder + "/assets/plusstudio/" + this.viewType + "/"
      ),
      assetOrder: null,
    };
  },

  created() {
    BunnyNetService.getFolders(this.folderStructure)
      .then((response) => {
        // Remap array
        const menuItems = response.data.map((item) => {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            ComponentName: this.componentName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
          };
        });
        // Assign type menu array
        if (this.viewType === "360-tour") {
          this.assetOrder = this.theme.tourMenuOrder;
        }
        // Sort array
        const customMenu = sortArray(menuItems, {
          by: ["LinkName"],
          order: "LinkName",
          customOrders: {
            LinkName: this.assetOrder,
          },
        });
        this.assetTypes = customMenu;
      })
      .catch((error) => {
        console.log(error);
      }),
      BunnyNetService.getCollections(
        this.theme.videoLibraryId,
        this.collectionName
      )
        .then((response) => {
          this.collection = response.data[0];
        })
        .catch((error) => {
          console.log(error);
        });
  },

  setup() {
    // load global config
    const { theme } = global;

    return {
      theme,
    };
  },
};
</script>
